import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Footer from "../components/Footer";
import TermsCondition from "../components/TermsCondition";
import { Helmet } from "react-helmet-async";

const TermsPage = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Read the Terms and Conditions for using TimeWatch Infocom’s services and products, including our advanced biometric solutions, access control systems, and security technologies. By accessing our website or using our products, you agree to comply with our legal policies on privacy, data protection, and service usage. This page outlines the terms governing the use of our time attendance systems, entrance automation, parking management solutions, and other smart security technologies. Ensure a clear understanding of our policies and user agreements for a secure experience."
        />
        <link
          rel="canonical"
          href="https://www.timewatchindia.com/terms-conditions"
        />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="terms">
          <TermsCondition />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default TermsPage;
